module.exports = __webpack_public_path__ + "static/PGR-cd1145428724264dc4cd146df5baa745.png";